<div *ngIf="!!((filterFields && filterFields.length) || hasDateRangeFilter)">
  <app-report-filter (filterTriggered)="appendFilter($event)" [filterFields]="filterFields"
                      [hasDateRanges]="hasDateRangeFilter" [singleDates]="singleDates"
                     [hasAssignedBusinessesFilter]="hasAssignedBusinessesFilter" (assignedBusinessesChanged)="assignedBusinessesChanged($event)">
                    </app-report-filter>
</div>

<div>
  <app-report-table (searchChanges)="searchChanges($event)" (toggleFilter)="toggleFilters($event)"
                    (paginationEvent)="paginationEvents($event)" (rowActionClicked)="rowActionClickedIn($event)"
                    (sortClick)="sortClicks($event)" (ExtpendableRowClicke)="extpendableRowClick($event)"
                    [ExtpendableColumn]="ExtpendableColumn"
                    [showReportName]="showReportName"
                    (ExtpendableColumnClick)="extpendableColumnClicks($event)" (selectionActionClick)="selectionActionClicks($event)"
                    [hasCheckboxes]="hasCheckboxes" [selectionActions]="selectionActions"
                    [usingTableComponent]="tableName" [tableLoading]="tableLoading" [columnNameToClick]="columnNameToClick"
                    [tableName]="reportName" [defaultColumns]="defaultColumns" [columnsDisplayNames]="columnsDisplayNames"
                    [LinkingCoulmns]="LinkingCoulmns" [isClickable]="isClickable" [data]="data" [rowsLength]="rowsLength"
                    [hasFilters]="!!((filterFields && filterFields.length) || hasDateRangeFilter)" [hasSorting]="hasSort"
                    [rowActions]="rowActions" [rowActionKeyName]="rowActionKeyName"
                    [customSelectionRows]="customSelectionRows" [total]="totalObject" [serviceInstance]="serviceInstance"
                    [reportSaveName]="reportSaveName" [identifierKey]="identifierKey" [columnTypes]="columnTypes"
                    [selection]="selectionModel" [hasCancelRequest]="hasCancelRequest" [showTopBar]="showTopBar">
  </app-report-table>
</div>
